import { CSSProperties } from "react";
import { GrCheckbox, GrCheckboxProps, GrStack } from "@jnpmedi/grebob";
import { MvnMessage } from "@newLibs/utils";
import { UseBoolean } from "@newHooks/common/useBoolean";
import { DOCS_FOLDER_LANG } from "@maven-msg/lang/docs";

interface ShowDeletedItemCheckboxProps {
  isDeletedResource: UseBoolean;
  label?: GrCheckboxProps["label"];
  style?: CSSProperties;
}

export const SHOW_DELETED_ITEM_HTML_FOR = "show-deleted-item";
export function ShowDeletedItemCheckbox({ isDeletedResource, label, style }: ShowDeletedItemCheckboxProps) {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  const defaultCheckboxLabel: GrCheckboxProps["label"] = {
    htmlFor: SHOW_DELETED_ITEM_HTML_FOR,
    text: MvnMessage(DOCS_FOLDER_LANG.DOCS_SHOW_DELETED_ITEM),
  };

  return (
    <GrStack onClick={handleClick} style={style}>
      <GrCheckbox
        checked={isDeletedResource.value}
        onChange={(_, checked) => isDeletedResource.setValue(checked)}
        id={SHOW_DELETED_ITEM_HTML_FOR}
        label={label || defaultCheckboxLabel}
      />
    </GrStack>
  );
}
